export const Bookmark = () => {
    return (
        <div>
            <h1 className="text-3xl text-slate-100 font-bold">Bookmark</h1>
        </div>
    )
}